import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
    create_rawtransection,
    getSuppliers,
    getRawMaterials,
    getUnits,
    postGeneralData
} from "../../../Utility/Api";
import { getFormattedCurrentDate2, onReqCreatePayment } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import PaymentModal from "../../Common/PaymentModal";
import CashModal from "../SalesWindow/modal/CashModal";
import CashCardModal from "../SalesWindow/modal/CashCardModal";
import CardModal from "../Purchase/modal/CardModal";

export const EditRawTransection = ({
    showModal,
    setShowModal,
    fetchRawmaterials,
    selectedRawmaterial,
    AddorEdit,
    transactionType,
    preSelectedMaterial,
    setCurrentPage,
}) => {
    const { showLoader, hideLoader, UserItem, shopItem, warehouse, parentCompany } = useContext(WarehouseContext);

    // Check if transaction type is "take"
    const isTakeTransaction = transactionType === "0";

    const [formData, setFormData] = useState({
        raw_mat_id: "",
        qty: "",
        add_taken: transactionType || "1",
        unit_id: "",
        supplier_id: "",
        credit: "",
        price_unit: "",
        price: "",
        payment_status: "",
        payment_remaining: "",
        transaction_id: "",
        expdate: "",
        mfgdate: "",
        product_code: "",
        batch_no: "",
        product_id: "",
        remarks: "",
        created_by: UserItem?.user_id || "0",
    });

    const [errors, setErrors] = useState({});
    const [suppliers, setSuppliers] = useState([]);
    const [rawMaterialsList, setRawMaterialsList] = useState([]);
    const [unitsList, setUnitsList] = useState([]);
    const [selectedMaterialDetails, setSelectedMaterialDetails] = useState(null);
    const [rows, setRows] = useState([]);

    // Additional state for summary calculations
    const [total, setTotal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [vat, setVat] = useState(0);
    const [freightCharges, setFreightCharges] = useState(0);
    const [otherCharges, setOtherCharges] = useState(0);
    const [previousDue, setPreviousDue] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [balance, setBalance] = useState(0);
    const [submitErrors, setSubmitErrors] = useState("");
    const [showPayModal, setShowPayModal] = useState(false);
    const [input, setInput] = useState("");
    const [cashShow, setCashShow] = useState(false);
    const [cardShow, setCardShow] = useState(false);
    const [cashCardShow, setCashCardShow] = useState(false);
    const [paymentType, setPaymentType] = useState("cash"); // Default payment type



    useEffect(() => {
        fetchSuppliers();
        fetchRawMaterialsList();
        fetchUnitsList();

        if (selectedRawmaterial && !AddorEdit) {
            // Edit mode
            setFormData({
                ...formData,
                raw_mat_id: selectedRawmaterial?.raw_mat_id || "",
                qty: selectedRawmaterial?.qty || "",
                add_taken: selectedRawmaterial?.add_taken || "1",
                unit_id: selectedRawmaterial?.unit_id || "",
                supplier_id: selectedRawmaterial?.supplier_id || "",
                price: selectedRawmaterial?.price || "",
                payment_status: selectedRawmaterial?.payment_status || "",
                payment_remaining: selectedRawmaterial?.payment_remaining || "",
                transaction_id: selectedRawmaterial?.transaction_id || "",
                expdate: selectedRawmaterial?.expdate || "",
                mfgdate: selectedRawmaterial?.mfgdate || "",
                product_code: selectedRawmaterial?.product_code || "",
                batch_no: selectedRawmaterial?.batch_no || "",
                remarks: selectedRawmaterial?.remarks || "",
            });
        } else {
            // Add / Take mode
            const transactionId = `BATCH-${new Date().toISOString().slice(0, 10).replace(/-/g, '')}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`;

            // If it's a take transaction, populate with preSelectedMaterial data
            if (isTakeTransaction && preSelectedMaterial) {
                setFormData(prev => ({
                    ...prev,
                    // transaction_id: transactionId,
                    add_taken: transactionType,
                    raw_mat_id: preSelectedMaterial.raw_mat_id || preSelectedMaterial.id || "",
                    unit_id: preSelectedMaterial.unit_id || "",
                    price: preSelectedMaterial.price || "",
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    // transaction_id: transactionId,
                    add_taken: transactionType || "1",
                    raw_mat_id: preSelectedMaterial?.raw_mat_id || preSelectedMaterial?.id || "",
                    unit_id: preSelectedMaterial?.unit_id || "",
                }));
            }
        }
    }, [selectedRawmaterial, transactionType, preSelectedMaterial]);

    useEffect(() => {
        if (formData.expdate && !formData.expiryMonths) {
            const currentDate = new Date();
            const expiryDate = new Date(formData.expdate);

            // Calculate difference in months
            const monthsDiff =
                (expiryDate.getFullYear() - currentDate.getFullYear()) * 12 +
                (expiryDate.getMonth() - currentDate.getMonth());

            // Only set if positive (future)
            if (monthsDiff > 0 && monthsDiff <= 24) {
                setFormData((prev) => ({
                    ...prev,
                    expiryMonths: monthsDiff,
                }));
            }
        }
    }, [formData.expdate]);

    useEffect(() => {
        if (formData.qty && formData.price_unit) {
            const totalAmount = parseFloat(formData.qty) * parseFloat(formData.price_unit);
            setFormData(prev => ({
                ...prev,
                price: totalAmount.toFixed(2)
            }));
        }
    }, [formData.qty, formData.price_unit]);

    useEffect(() => {
        if (formData.raw_mat_id && rawMaterialsList.length > 0) {
            const material = rawMaterialsList.find(m => m.id == formData.raw_mat_id);
            setSelectedMaterialDetails(material);

            if (isTakeTransaction && material) {
                setFormData(prev => ({
                    ...prev,
                    unit_id: material.unit_id || prev.unit_id,
                    price: material.price || prev.price
                }));
            }
        }
    }, [formData.raw_mat_id, rawMaterialsList, isTakeTransaction]);

    const fetchSuppliers = async () => {
        try {
            const response = await getSuppliers();
            if (response.data && response.data.data) {
                setSuppliers(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching suppliers:", error);
        }
    };

    const fetchRawMaterialsList = async () => {
        try {
            const response = await getRawMaterials();
            if (response.data && response.data.data) {
                setRawMaterialsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
        }
    };

    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const handleSubmit1 = async (e) => {
        e.preventDefault();
        setSubmitErrors("");

        if (rows.length === 0) {
            setSubmitErrors("Please add at least one item to the table before submitting.");
            toast.error("Please add at least one item to the table before submitting.");
            return;
        }

        showLoader();

        try {
            const shop_id = parseInt(shopItem?.id || localStorage.getItem("shop_id") || "0");
            const warehouse_id = parseInt(warehouse?.id || localStorage.getItem("warehouse_id") || "0");
            const branch_id = parseInt(parentCompany?.id || localStorage.getItem("branch_id") || "0");
            const user_id = parseInt(UserItem?.user_id || "0");
            console.log("Supplier ID before submit:", formData.supplier_id);


            // Build the data array from all rows
            const dataArray = rows.map(row => ({
                raw_mat_id: parseInt(row.raw_mat_id),
                qty: parseFloat(row.qty),
                add_taken: formData.add_taken,
                unit_id: parseInt(row.unit_id),
                supplier_id: formData.supplier_id,
                price: parseFloat(row.total_amount),
                price_unit: parseFloat(row.purchase_price),
                warehouse_id: warehouse_id,
                shop_id: shop_id,
                branch_id: branch_id,
                created_by: user_id,
                transaction_id: formData.transaction_id || "",
                expdate: row.expiry_date || "",
                mfgdate: row.manufactured_date || "",
                product_code: row.item_code || "",
                remarks: `${row.qty} units of ${row.product_name}`,
                payment_status: formData.payment_status || "",
            }));

            const payload = {
                data: dataArray
            };

            console.log("Submitting payload:", payload);

            const response = await create_rawtransection(payload);

            if (response?.data?.status === "success") {
                // Handle general data entries for "add" transactions
                if (formData.add_taken === "1") {
                    for (const row of rows) {
                        try {
                            const generalDataPayload = {
                                type: "3",
                                ref_id: String(row.raw_mat_id),
                                remarks: "Raw Material",
                                date: getFormattedCurrentDate2(),
                                created_by: String(user_id),
                                shop_id: String(shop_id),
                                amount: String(row.total_amount),
                                is_debit: "1",
                            };
                            await postGeneralData(generalDataPayload);

                            const generalDataPayload1 = {
                                type: "2",
                                ref_id: String(row.raw_mat_id),
                                remarks: "Bank - To Raw Material",
                                date: getFormattedCurrentDate2(),
                                created_by: String(user_id),
                                shop_id: String(shop_id),
                                amount: String(row.total_amount),
                                is_debit: "0",
                            };
                            await postGeneralData(generalDataPayload1);
                        } catch (e) {
                            console.error("Error saving general data", e);
                        }
                    }
                }

                toast.success(`Raw Materials ${formData.add_taken === "1" ? "added" : "taken"} successfully`);
                fetchRawmaterials();
                handleCancel();
            } else {
                toast.error(response?.data?.message || "Error saving Raw Materials");
            }
        } catch (error) {
            console.error("Error saving Raw Material data:", error);
            toast.error(error?.response?.data?.message || "Error saving Raw Material");
        } finally {
            hideLoader();
        }
    };
    const handleSubmit2 = async (type = "1") => {
        // e.preventDefault(); // Remove this as we're not using event anymore
        setSubmitErrors("");

        if (rows.length === 0) {
            setSubmitErrors("Please add at least one item to the table before submitting.");
            toast.error("Please add at least one item to the table before submitting.");
            return;
        }

        showLoader();

        try {
            const shop_id = parseInt(shopItem?.id || localStorage.getItem("shop_id") || "0");
            const warehouse_id = parseInt(warehouse?.id || localStorage.getItem("warehouse_id") || "0");
            const branch_id = parseInt(parentCompany?.id || localStorage.getItem("branch_id") || "0");
            const user_id = parseInt(UserItem?.user_id || "0");

            // Calculate payment details
            const grandTotalAmount = parseFloat(grandTotal || 0);
            const paidAmount = parseFloat(input || grandTotalAmount);
            let payment_status = "cash";
            let payment_remaining = "0";

            // Determine payment status based on type
            if (type === "2") { // Credit
                payment_status = "credit";
                payment_remaining = grandTotalAmount.toString();
            } else if (type === "1" || type === "4" || type === "5") { // Cash, Card, or Cash+Card
                if (paidAmount < grandTotalAmount) {
                    payment_status = "partial";
                    payment_remaining = (grandTotalAmount - paidAmount).toString();
                } else {
                    payment_status = "cash";
                    payment_remaining = "0";
                }
            }

            // Build the data array from all rows
            const dataArray = rows.map(row => ({
                raw_mat_id: parseInt(row.raw_mat_id),
                qty: parseFloat(row.qty),
                add_taken: formData.add_taken,
                unit_id: parseInt(row.unit_id),
                supplier_id: formData.supplier_id ? parseInt(formData.supplier_id) : null,
                price: parseFloat(row.total_amount),
                price_unit: parseFloat(row.purchase_price),
                warehouse_id: warehouse_id,
                shop_id: shop_id,
                branch_id: branch_id,
                created_by: user_id,
                transaction_id: formData.transaction_id || "",
                expdate: row.expiry_date || "",
                mfgdate: row.manufactured_date || "",
                product_code: row.item_code || "",
                remarks: `${row.qty} units of ${row.product_name}`,
                payment_status: payment_status,
                payment_remaining: payment_remaining,
            }));

            const payload = {
                data: dataArray
            };

            console.log("Submitting payload:", payload);

            const response = await create_rawtransection(payload);

            if (response?.data?.status === "success") {
                // Handle general data entries for "add" transactions
                if (formData.add_taken === "1") {
                    for (const row of rows) {
                        try {
                            const generalDataPayload = {
                                type: "3",
                                ref_id: formData.transaction_id,
                                remarks: "Raw Material Purchase",
                                date: getFormattedCurrentDate2(),
                                created_by: String(user_id),
                                shop_id: String(shop_id),
                                amount: String(row.total_amount),
                                is_debit: "1",
                            };
                            await postGeneralData(generalDataPayload);

                            // Only add bank entry if payment was made (not credit)
                            if (type !== "2") {
                                const generalDataPayload1 = {
                                    type: "2",
                                    ref_id: formData.transaction_id,
                                    remarks: "Bank - To Raw Material",
                                    date: getFormattedCurrentDate2(),
                                    created_by: String(user_id),
                                    shop_id: String(shop_id),
                                    amount: String(paidAmount),
                                    is_debit: "0",
                                };
                                await postGeneralData(generalDataPayload1);
                            }
                        } catch (e) {
                            console.error("Error saving general data", e);
                        }
                    }
                }

                toast.success(`Raw Materials ${formData.add_taken === "1" ? "added" : "taken"} successfully`);
                fetchRawmaterials();
                handleCancel();
            } else {
                toast.error(response?.data?.message || "Error saving Raw Materials");
            }
        } catch (error) {
            console.error("Error saving Raw Material data:", error);
            toast.error(error?.response?.data?.message || "Error saving Raw Material");
        } finally {
            hideLoader();
        }
    };

    const handleSubmit = async (type = "1") => {
        setSubmitErrors("");

        if (rows.length === 0) {
            setSubmitErrors("Please add at least one item to the table before submitting.");
            toast.error("Please add at least one item to the table before submitting.");
            return;
        }

        showLoader();

        try {
            const shop_id = parseInt(shopItem?.id || localStorage.getItem("shop_id") || "0");
            const warehouse_id = parseInt(warehouse?.id || localStorage.getItem("warehouse_id") || "0");
            const branch_id = parseInt(parentCompany?.id || localStorage.getItem("branch_id") || "0");
            const user_id = parseInt(UserItem?.user_id || "0");

            // Calculate payment details
            const grandTotalAmount = parseFloat(grandTotal || 0).toFixed(3);
            const pendingAmount = Math.abs(parseFloat(getReminingValue())).toFixed(3);
            let paidAmount = parseFloat(grandTotalAmount).toFixed(3);
            let purchase_type = "0";

            // Calculate paid amount based on input
            if (parseFloat(input) < grandTotalAmount) {
                paidAmount = input;
                purchase_type = "2"; // Partial payment
            } else {
                purchase_type = type;
            }

            if (type == "2") {
                paidAmount = 0;
                pendingAmount = parseFloat(grandTotalAmount).toFixed(3);
            }

            // Prepare payment data
            const paydata = {
                orderID: formData.transaction_id,
                date: getFormattedCurrentDate2(),
                amount: "0",
                total_amount: grandTotalAmount,
                cash: 0,
                credit: 0,
                card: 0,
                type: 3, // Type 3 for raw material transactions (1 is for purchase, 2 is for sales)
                mop: "0",
                complete: "0",
            };

            if (type == "1") { // Cash
                if (pendingAmount > 0) {
                    paydata.cash = paidAmount;
                    paydata.credit = pendingAmount;
                    paydata.card = 0;
                    paydata.mop = "1,2";
                    purchase_type = "2";
                } else {
                    paydata.cash = paidAmount;
                    paydata.credit = 0;
                    paydata.card = 0;
                    paydata.mop = "1";
                    purchase_type = "1";
                    paydata.complete = "1";
                }
            } else if (type == "2") { // Credit
                paydata.cash = paidAmount;
                paydata.credit = pendingAmount;
                paydata.card = 0;
                paydata.mop = "2";
                purchase_type = "2";
            } else if (type == "4") { // Card
                if (pendingAmount > 0) {
                    paydata.cash = 0;
                    paydata.credit = pendingAmount;
                    paydata.card = paidAmount;
                    paydata.mop = "2,4";
                    purchase_type = "2";
                } else {
                    paydata.cash = 0;
                    paydata.credit = 0;
                    paydata.card = paidAmount;
                    paydata.mop = "4";
                    purchase_type = "1";
                    paydata.complete = "1";
                }
            } else if (type == "5") { // Cash+Card
                purchase_type = "1";
                paydata.complete = "1";
                if (pendingAmount > 0) {
                    paydata.cash = paidAmount;
                    paydata.credit = 0;
                    paydata.card = pendingAmount;
                    paydata.mop = "1,4";
                } else {
                    paydata.cash = paidAmount;
                    paydata.credit = 0;
                    paydata.card = 0;
                    paydata.mop = "1";
                }
            }

            // Build the data array from all rows
            const dataArray = rows.map(row => ({
                raw_mat_id: parseInt(row.raw_mat_id),
                qty: parseFloat(row.qty),
                add_taken: formData.add_taken,
                unit_id: parseInt(row.unit_id),
                supplier_id: formData.supplier_id ? parseInt(formData.supplier_id) : null,
                price: parseFloat(row.total_amount),
                price_unit: parseFloat(row.purchase_price),
                warehouse_id: warehouse_id,
                shop_id: shop_id,
                branch_id: branch_id,
                created_by: user_id,
                transaction_id: formData.transaction_id || "",
                expdate: row.expiry_date || "",
                mfgdate: row.manufactured_date || "",
                product_code: row.item_code || "",
                remarks: `${row.qty} units of ${row.product_name}`,
                payment_status: purchase_type == "2" ? "credit" : "cash",
                payment_remaining: purchase_type == "2" ? grandTotalAmount : "0",
            }));

            const payload = {
                data: dataArray
            };

            console.log("Submitting payload:", payload);

            const response = await create_rawtransection(payload);

            await onReqCreatePayment(paydata);

            hideLoader();

            if (response?.data?.status === "success") {
                if (formData.add_taken === "1") {
                    try {
                        const generalDataPayload = {
                            type: "3",
                            ref_id: formData.transaction_id,
                            remarks: "Raw Material Purchase",
                            date: getFormattedCurrentDate2(),
                            created_by: String(user_id),
                            shop_id: String(shop_id),
                            amount: String(grandTotalAmount),
                            is_debit: "1",
                        };
                        await postGeneralData(generalDataPayload);

                        const generalDataPayload1 = {
                            type: "2",
                            ref_id: formData.transaction_id,
                            remarks: "Bank - To Raw Material Purchase",
                            date: getFormattedCurrentDate2(),
                            created_by: String(user_id),
                            shop_id: String(shop_id),
                            amount: String(paidAmount),
                            is_debit: "0",
                        };
                        await postGeneralData(generalDataPayload1);

                        if (paydata?.complete == "0") {
                            const generalDataPayload2 = {
                                type: "7",
                                ref_id: formData.transaction_id,
                                remarks: "Raw Material Purchase Credit",
                                date: getFormattedCurrentDate2(),
                                created_by: String(user_id),
                                shop_id: String(shop_id),
                                amount: String(pendingAmount),
                                is_debit: "0",
                            };
                            await postGeneralData(generalDataPayload2);
                        }
                    } catch (e) {
                        console.error("Error saving general data", e);
                    }
                }

                toast.success(`Raw Materials ${formData.add_taken === "1" ? "added" : "taken"} successfully`);
                fetchRawmaterials();
                handleCancel();
            } else {
                toast.error(response?.data?.message || "Error saving Raw Materials");
            }
        } catch (error) {
            hideLoader();
            console.error("Error saving Raw Material data:", error);
            toast.error(error?.response?.data?.message || "Error saving Raw Material");
        }
    };



    const handlePaymentType = (type) => {
        if (type == "1") {
            setCashShow(true);
            setInput("");
        } else if (type == "2") {
            handleSubmit(type);
        } else if (type == "5") {
            setCashCardShow(true);
            setInput("");
        } else if (type == "4") {
            setCardShow(true);
            setInput("");
        }
        setShowPayModal(false);
    };

    const handleClick = (value) => {
        setInput((prev) => {
            if (value === ".") {
                if (prev.includes(".") || prev === "") return prev;
            }
            return prev + value;
        });
    };

    const handleBackspace = () => {
        setInput((prev) => prev.slice(0, -1));
    };

    const getAmountDue = () => grandTotal.toFixed(2);

    const getReturnValue = () => {
        const amountDue = parseFloat(getAmountDue() || 0);
        if (amountDue <= 0) return amountDue.toFixed(2);

        return input &&
            !isNaN(input) &&
            /^\d+(\.\d{1,2})?$/.test(input) &&
            parseFloat(input) >= amountDue
            ? (parseFloat(input) - amountDue)?.toFixed(2)
            : "0";
    };

    const getReminingValue = () => {
        const amountDue = parseFloat(getAmountDue() || 0);
        if (amountDue <= 0) return amountDue.toFixed(2);

        return input &&
            !isNaN(input) &&
            /^\d+(\.\d{1,2})?$/.test(input) &&
            parseFloat(input) <= amountDue
            ? (parseFloat(input) - amountDue)?.toFixed(2)
            : "0";
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
        setErrors(prev => ({
            ...prev,
            [name]: "",
        }));
    };

    const resetForm = () => {
        setFormData({
            ...formData,
            raw_mat_id: "",
            qty: "",
            unit_id: "",
            price_unit: "",
            payment_status: "",
            price: "",
            supplier_id: "",
            product_code: "",
            batch_no: "",
        });
        setErrors({});
    };

    const handleCancel = () => {
        setShowModal(false);
        resetForm();
        setRows([]);
        setTotal(0);
        setDiscount(0);
        setVat(0);
        setFreightCharges(0);
        setOtherCharges(0);
        setPreviousDue(0);
        setGrandTotal(0);
        setBalance(0);
        setSubmitErrors("");
    };

    const handleAddRow = () => {
        const validationErrors = {};
        if (!formData.raw_mat_id) validationErrors.raw_mat_id = "Raw material is required.";
        if (!formData.qty) {
            validationErrors.qty = "Quantity is required.";
          } else if (Number(formData.qty) <= 0) {
            validationErrors.qty = "Quantity must be greater than 0.";
          } else if (Number(formData.qty) > Number(formData.remaining_stock)) {
            validationErrors.qty = `Quantity cannot be greater than available stock (${formData.remaining_stock}).`;
          }
        if (!formData.unit_id) validationErrors.unit_id = "Unit is required.";
        if (!formData.price_unit) validationErrors.price_unit = "Price is required.";

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        // Material and unit names
        const materialName = rawMaterialsList.find(m => m.id == formData.raw_mat_id)?.title || "";
        const unitName = unitsList.find(u => u.id == formData.unit_id)?.title || "";
        // const supplierName = suppliers.find(s => s.id == formData.supplier_id)?.full_name || "";

        const newRow = {
            id: rows.length + 1,
            product_name: materialName,
            item_code: formData.product_code || "",
            qty: formData.qty,
            purchase_price: formData.price_unit,
            total_amount: formData.price,
            unit_name: unitName,
            manufactured_date: formData.mfgdate || "",
            expiry_date: formData.expdate || "",
            raw_mat_id: formData.raw_mat_id,
            unit_id: formData.unit_id,
        };

        setRows([...rows, newRow]);

        // Update total
        const newTotal = parseFloat(total) + parseFloat(formData.price || 0);
        setTotal(newTotal);
        calculateGrandTotal(newTotal);

        // Reset all form fields for new entry
        setFormData(prev => ({
            ...prev,
            raw_mat_id: "",
            qty: "",
            unit_id: "",
            mfgdate: "",
            expdate: "",
            expiryMonths: "",
            price_unit: "",
            price: "",
            product_code: "",
            batch_no: "",
        }));
        setErrors({});
    };


    const calculateGrandTotal = (newTotal) => {
        const discountAmount = (newTotal * discount) / 100;
        const vatAmount = (newTotal * vat) / 100;
        const calculatedGrandTotal = newTotal - discountAmount + vatAmount + parseFloat(freightCharges || 0) + parseFloat(otherCharges || 0);
        setGrandTotal(calculatedGrandTotal);
        setBalance(calculatedGrandTotal + parseFloat(previousDue || 0));
    };

    const handleRemoveRow = (id) => {
        const rowToRemove = rows.find(row => row.id === id);
        const newRows = rows.filter(row => row.id !== id);
        setRows(newRows);

        // Update total
        if (rowToRemove) {
            const newTotal = parseFloat(total) - parseFloat(rowToRemove.total_amount || 0);
            setTotal(newTotal >= 0 ? newTotal : 0);
            calculateGrandTotal(newTotal >= 0 ? newTotal : 0);
        }
    };

    const handleDiscountChange = (e) => {
        const value = e.target.value;
        setDiscount(value);
        calculateGrandTotal(total);
    };

    const handleVatChange = (e) => {
        const value = e.target.value;
        setVat(value);
        calculateGrandTotal(total);
    };

    const handleChargesChange = (field, value) => {
        switch (field) {
            case 'freight':
                setFreightCharges(value);
                break;
            case 'other':
                setOtherCharges(value);
                break;
            case 'previous':
                setPreviousDue(value);
                break;
        }
        calculateGrandTotal(total);
    };

    return (
        <>
            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                                    {AddorEdit ? (formData.add_taken === "1" ? "Add Raw Material Transaction" : "Take Raw Material") : "Edit Transaction"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={handleCancel}
                                ></button>
                            </div>

                            <div className="modal-body" style={{ fontFamily: "poppins" }}>
                                {/* Top Form Section - Mimicking your UI */}
                                <div className="p-3 bg-white rounded shadow-sm mb-4">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label className="mb-1">Raw Material</label>
                                            <select
                                                name="raw_mat_id"
                                                value={formData.raw_mat_id}
                                                onChange={handleChange}
                                                className={`form-control form-control-sm ${errors.raw_mat_id ? 'is-invalid' : ''}`}
                                                disabled={isTakeTransaction && preSelectedMaterial}
                                            >
                                                <option value="">Select Raw Material</option>
                                                {rawMaterialsList.map((item) => (
                                                    <option key={item.id} value={item.id}>{item.title}</option>
                                                ))}
                                            </select>
                                            {errors.raw_mat_id && <div className="invalid-feedback">{errors.raw_mat_id}</div>}
                                        </div>

                                        <div className="col-md-3">
                                            <label className="mb-1">Qty</label>
                                            <input
                                                type="number"
                                                name="qty"
                                                value={formData.qty}
                                                onChange={handleChange}
                                                className={`form-control form-control-sm ${errors.qty ? 'is-invalid' : ''}`}
                                                placeholder="Enter Quantity"
                                                min="0"
                                            />
                                            {errors.qty && <div className="invalid-feedback">{errors.qty}</div>}
                                        </div>

                                        <div className="col-md-3">
                                            <label className="mb-1"> Unit</label>
                                            <select
                                                name="unit_id"
                                                value={formData.unit_id}
                                                onChange={handleChange}
                                                className={`form-control form-control-sm ${errors.unit_id ? 'is-invalid' : ''}`}
                                                disabled={isTakeTransaction}
                                            >
                                                <option value="">Select Units</option>
                                                {unitsList.map((s) => (
                                                    <option key={s.id} value={s.id}>{s.title}</option>
                                                ))}
                                            </select>
                                            {errors.unit_id && <div className="invalid-feedback">{errors.unit_id}</div>}
                                        </div>

                                        <div className="col-md-3">
                                            <div className="d-grid gap-2 mt-4">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={handleAddRow}
                                                    type="button"
                                                >
                                                    Add Row
                                                </button>
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <label className="mb-1">Product code</label>
                                            <input
                                                type="text"
                                                name="product_code"
                                                value={formData.product_code}
                                                onChange={handleChange}
                                                className="form-control form-control-sm"
                                                placeholder="Product code"
                                                readOnly={isTakeTransaction}
                                            />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="mb-1">Price (INR)</label>
                                            <input
                                                type="number"
                                                name="price_unit"
                                                value={formData.price_unit}
                                                onChange={handleChange}
                                                className={`form-control form-control-sm ${errors.price_unit ? 'is-invalid' : ''}`}
                                                placeholder="Enter Price"
                                                // readOnly={isTakeTransaction && selectedMaterialDetails}
                                            />
                                            {errors.price_unit && <div className="invalid-feedback">{errors.price_unit}</div>}
                                        </div>

                                        <div className="col-md-3">
                                            <label className="mb-1">Total amount (INR)</label>
                                            <input
                                                type="number"
                                                name="price"
                                                value={formData.price}
                                                onChange={handleChange}
                                                className="form-control form-control-sm"
                                                placeholder="Enter Amount"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-md-3">
                                            <div className="d-grid gap-2 mt-4">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={resetForm}
                                                    type="button"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>

                                        {!isTakeTransaction && (
                                            <>
                                                <div className="col-md-3">
                                                    <label className="mb-1">Supplier</label>
                                                    <select
                                                        name="supplier_id"
                                                        value={formData.supplier_id}
                                                        onChange={handleChange}
                                                        className="form-control form-control-sm"
                                                    >
                                                        <option value="">Select Supplier</option>
                                                        {suppliers.map((s) => (
                                                            <option key={s.supplier_id} value={s.supplier_id}>{s.full_name}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="col-md-3">
                                                    <label className="mb-1">Payment <span className="text-danger">*</span></label>
                                                    <select
                                                        name="payment_status"
                                                        value={formData.payment_status}
                                                        onChange={handleChange}
                                                        className="form-control form-control-sm"
                                                    >
                                                        <option value="cash">Cash</option>
                                                        <option value="credit">Credit</option>
                                                    </select>
                                                </div>

                                                <div className="col-md-3 d-none">
                                                    <label className="mb-1">Sales Rate (INR)</label>
                                                    <input
                                                        type="number"
                                                        name="sales_rate"
                                                        value={formData.sales_rate || formData.price_unit}
                                                        onChange={handleChange}
                                                        className="form-control form-control-sm"
                                                        placeholder="Enter Rate"
                                                    />
                                                </div>

                                                <div className="col-md-3">
                                                    <label className="mb-1">Manufactured Date</label>
                                                    <input
                                                        type="date"
                                                        name="mfgdate"
                                                        value={formData.mfgdate}
                                                        onChange={handleChange}
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>

                                                <div className="col-md-3">
                                                    <label className="mb-1">Expiry Date <span className="text-danger">*</span></label>
                                                    <select
                                                        name="expdate"
                                                        value={formData.expiryMonths || ""}
                                                        onChange={(e) => {
                                                            const months = parseInt(e.target.value, 10);
                                                            const currentDate = new Date();
                                                            currentDate.setMonth(currentDate.getMonth() + months);
                                                            const expiryDate = currentDate.toISOString().split("T")[0];

                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                expiryMonths: months,
                                                                expdate: expiryDate,
                                                            }));
                                                            setErrors((prev) => ({
                                                                ...prev,
                                                                expdate: "",
                                                            }));
                                                        }}
                                                        className={`form-control form-control-sm ${errors.expdate ? "is-invalid" : ""}`}
                                                    >
                                                        <option value="">Select Duration</option>
                                                        {[...Array(24)].map((_, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                                {i + 1} Month{i + 1 > 1 ? "s" : ""}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {formData.expdate && (
                                                        <small className="text-muted d-block">
                                                            Expiry: {formData.expdate}
                                                        </small>
                                                    )}
                                                    {errors.expdate && <div className="invalid-feedback">{errors.expdate}</div>}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Table Section */}
                                <div className="row">
                                    <div className="col-md-8">
                                        {submitErrors && (
                                            <div className="alert alert-danger" role="alert">
                                                {submitErrors}
                                            </div>
                                        )}
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover table-sm">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Raw Material</th>
                                                        <th>PDCode</th>
                                                        <th>Qty</th>
                                                        <th>P_Price</th>
                                                        <th>Total</th>
                                                        {/* <th>Sales Rate</th> */}
                                                        <th>Mgf Date</th>
                                                        {/* <th>Expiry Date</th> */}
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rows.length > 0 ? (
                                                        rows.map((row, index) => (
                                                            <tr key={row.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{row.product_name}</td>
                                                                <td>{row.item_code}</td>
                                                                <td>{row.qty}</td>
                                                                <td>{row.purchase_price}</td>
                                                                <td>{row.total_amount}</td>
                                                                {/* <td>{row.sales_rate}</td> */}
                                                                <td>{row.manufactured_date}</td>
                                                                {/* <td>{row.expiry_date}</td> */}
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => handleRemoveRow(row.id)}
                                                                    >
                                                                        <i className="bi bi-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="10" className="text-center">No items added yet</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>


                                    {/* <div className="col-md-8">
                                        <div className="mb-3">
                                            <label className="mb-1">Remarks</label>
                                            <textarea
                                                name="remarks"
                                                value={formData.remarks}
                                                onChange={handleChange}
                                                className="form-control form-control-sm"
                                                placeholder={isTakeTransaction ? "Reason for taking raw material" : "Any additional notes"}
                                                rows="3"
                                            />
                                        </div>
                                    </div> */}

                                    <div className="col-md-4">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <div className="row mb-2 align-items-center">
                                                    <div className="col-6">Total (INR)</div>
                                                    <div className="col-6">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={total.toFixed(2)}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2 align-items-center">
                                                    <div className="col-6 fw-semibold">Discount</div>
                                                    <div className="col-3">
                                                        <div className="input-group input-group-sm align-items-center" style={{ maxWidth: '120px' }}>
                                                            <input
                                                                type="number"
                                                                className="form-control text-end"
                                                                value={discount}
                                                                onChange={handleDiscountChange}
                                                                style={{ fontSize: '0.9rem', height: '30px' }}
                                                            />
                                                            <span
                                                                className="input-group-text"
                                                                style={{
                                                                    fontSize: '0.8rem',
                                                                    padding: '0 6px',
                                                                    height: '30px',
                                                                    lineHeight: '1',
                                                                }}
                                                            >
                                                                %
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-3">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm text-end"
                                                            value={(total * discount / 100).toFixed(2)}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2 align-items-center">
                                                    <div className="col-6 fw-semibold">VAT</div>
                                                    <div className="col-3">
                                                        <div className="input-group input-group-sm align-items-center" style={{ maxWidth: '120px' }}>
                                                            <input
                                                                type="number"
                                                                className="form-control text-end"
                                                                value={vat}
                                                                onChange={handleVatChange}
                                                                style={{ fontSize: '0.9rem', height: '30px' }}
                                                            />
                                                            <span
                                                                className="input-group-text"
                                                                style={{
                                                                    fontSize: '0.8rem',
                                                                    padding: '0 6px',
                                                                    height: '30px',
                                                                    lineHeight: '1',
                                                                }}
                                                            >
                                                                %
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-3">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm text-end"
                                                            value={(total * vat / 100).toFixed(2)}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                {/* <div className="row mb-2 align-items-center">
                                                    <div className="col-6">Freight Charges</div>
                                                    <div className="col-6">
                                                        <input 
                                                            type="number" 
                                                            className="form-control form-control-sm" 
                                                            value={freightCharges}
                                                            onChange={(e) => handleChargesChange('freight', e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2 align-items-center">
                                                    <div className="col-6">Other Charges</div>
                                                    <div className="col-6">
                                                        <input 
                                                            type="number" 
                                                            className="form-control form-control-sm" 
                                                            value={otherCharges}
                                                            onChange={(e) => handleChargesChange('other', e.target.value)}
                                                        />
                                                    </div>
                                                </div> */}

                                                <div className="row mb-2 align-items-center">
                                                    <div className="col-6">Previous Due (INR)</div>
                                                    <div className="col-6">
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            value={previousDue}
                                                            onChange={(e) => handleChargesChange('previous', e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2 align-items-center">
                                                    <div className="col-6">Grand Total (INR)</div>
                                                    <div className="col-6">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={grandTotal.toFixed(2)}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mb-2 align-items-center">
                                                    <div className="col-6">Balance (INR)</div>
                                                    <div className="col-6">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={balance.toFixed(2)}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-12 text-center">
                                        {/* <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={handleSubmit}
                                            disabled={rows.length === 0}
                                        >
                                            Submit
                                        </button> */}
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => {
                                                if (rows.length === 0) {
                                                    toast.error("Please add at least one item");
                                                    return;
                                                }

                                                // For "Add" transactions, show payment modal
                                                if (formData.add_taken === "1") {
                                                    setShowPayModal(true);
                                                } else {
                                                    // For "Take" transactions, submit directly
                                                    handleSubmit("1");
                                                }
                                            }}
                                            disabled={rows.length === 0}
                                        >
                                            Submit
                                        </button>
                                        &nbsp;&nbsp;
                                        <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Payment Modal */}
                    <PaymentModal
                        show={showPayModal}
                        onClose={() => setShowPayModal(false)}
                        onSelectPayment={handlePaymentType}
                    />

                    <CashModal
                        show={cashShow}
                        onClose={() => setCashShow(false)}
                        input={input}
                        getAmountDue={getAmountDue}
                        getReturnValue={getReturnValue}
                        getReminingValue={getReminingValue}
                        handleClick={handleClick}
                        handleBackspace={handleBackspace}
                        handleSubmit={handleSubmit}
                    />

                    <CashCardModal
                        show={cashCardShow}
                        onClose={() => setCashCardShow(false)}
                        input={input}
                        getAmountDue={getAmountDue}
                        getReturnValue={getReturnValue}
                        getReminingValue={getReminingValue}
                        handleClick={handleClick}
                        handleBackspace={handleBackspace}
                        handleSubmit={handleSubmit}
                    />

                    <CardModal
                        show={cardShow}
                        onClose={() => setCardShow(false)}
                        input={input}
                        setInput={setInput}
                        getAmountDue={getAmountDue}
                        getReturnValue={getReturnValue}
                        getReminingValue={getReminingValue}
                        handleClick={handleClick}
                        handleBackspace={handleBackspace}
                        handleSubmit={handleSubmit}
                    />

                </div>
            )}

        </>
    );
};
